import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const SeparatorItem = styled.div`
	background: ${({ theme }) => theme.color.grayFive};
	height: ${rem(1)};
	margin: ${rem(30, -32)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background: ${({ theme }) => theme.color.primary};
		`}

	@media (${device.tablet}) {
		margin: ${rem(30, -15)};
	}
	@media (${device.mobileM}) {
		display: none;
	}
`
